import React from 'react';

const Logo = ({ height = 40, light = false, className = '' }) => {
  const textColor = light ? '#FFFFFF' : '#18181B';
  const subtextColor = light ? '#E2E8F0' : '#27272A';

  return (
    <div className={`kubersetu-brand-logo ${className}`} style={{ display: 'inline-flex', alignItems: 'center', gap: '0.75rem', textDecoration: 'none' }}>
      <svg
        height={height}
        viewBox="0 0 350 90"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ height: `${height}px`, width: 'auto', display: 'block' }}
      >
        <defs>
          <linearGradient id="ksPillarGrad" x1="0" y1="90" x2="0" y2="28" gradientUnits="userSpaceOnUse">
            <stop offset="0%" stopColor="#FDE047" />
            <stop offset="40%" stopColor="#F59E0B" />
            <stop offset="100%" stopColor="#EA580C" />
          </linearGradient>
          <linearGradient id="ksArrowHeadGrad" x1="0" y1="28" x2="0" y2="0" gradientUnits="userSpaceOnUse">
            <stop offset="0%" stopColor="#F59E0B" />
            <stop offset="100%" stopColor="#D97706" />
          </linearGradient>
        </defs>

        {/* Main Brand Text: KUBERSETU */}
        <text
          x="0"
          y="50"
          fill={textColor}
          fontFamily="'Outfit', 'Syne', 'Plus Jakarta Sans', system-ui, sans-serif"
          fontWeight="900"
          fontSize="48"
          letterSpacing="-0.02em"
        >
          KUBERSETU
        </text>

        {/* Subtitle: INFOTECH PRIVATE LIMITED */}
        <text
          x="1"
          y="74"
          fill={subtextColor}
          fontFamily="'Outfit', 'Plus Jakarta Sans', system-ui, sans-serif"
          fontWeight="800"
          fontSize="14.5"
          letterSpacing="0.22em"
        >
          INFOTECH PRIVATE LIMITED
        </text>

        {/* Upward Growth Pillar Icon */}
        <g transform="translate(292, 0)">
          {/* Main Pillar Body */}
          <rect
            x="4"
            y="26"
            width="32"
            height="52"
            rx="3"
            fill="url(#ksPillarGrad)"
          />
          {/* Upward Arrow Chevron Head */}
          <path
            d="M 20 0 L 40 22 L 30 22 L 30 26 L 10 26 L 10 22 L 0 22 Z"
            fill="url(#ksArrowHeadGrad)"
          />
        </g>
      </svg>
    </div>
  );
};

export default Logo;
